/** Normalize a test URL, prepending https:// only if no scheme is present. */
export function normalizeTestUrl(url: string): string {
  if (URL.canParse(url)) return url;
  const hasScheme = /^https?:\/\//i.test(url);
  if (!hasScheme && URL.canParse(`https://${url}`)) return `https://${url}`;
  return url;
}
